<template>
  <el-container id="app" style="height: 100%">
    <el-header v-if="!this.$store.state.isLogin">
      <Header></Header>
    </el-header>
    <el-container>
        <el-aside width="200px" v-if="!this.$store.state.isLogin">
          <Navigator/>
        </el-aside>
        <el-main>
          <HeaderTabs v-if="!this.$store.state.isLogin" />
          <router-view/>
        </el-main>


    </el-container>
  </el-container>

</template>

<script>
import Header from './components/Header'
import Navigator from './components/Navigator'
import HeaderTabs from './components/HeaderTabs'

export default {
  name: 'app',
  components: {
      Header,
      Navigator,
      HeaderTabs,
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  min-height: 1080px;
}
</style>
